export default "__VITE_ASSET__DFofS58o__"